import DetailVideoEpisode from './DetailVideoEpisode'

export default DetailVideoEpisode
// eslint-disable-next-line import/export
export * from './DetailVideoEpisode'
